import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router} from '@angular/router';
import {UserCacheService} from '../../services/user-cache.service';
import {AppConstants} from '../../constants/app-constants';

@Component({
    selector: 'app-left-nav-bar',
    templateUrl: './left-nav-bar.component.html',
    styleUrls: ['./left-nav-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LeftNavBarComponent implements OnInit {
  activeTab: any;
  participantId: any;

  constructor(public router: Router, public userCacheService: UserCacheService) {
    this.participantId = this.userCacheService.getUserData(AppConstants.PARTICIPATION_ID);
    this.activeTab = this.router.url;
  }

  ngOnInit(): void {
    // if (this.activeTab === null || this.activeTab === '') {
    //   this.activeTab = 'dashboard';
    //   this.userCacheService.setUserData(AppConstants.CURRENT_NAV_TAB, 'dashboard');
    // }
  }
  tabClick(tab): void {
    // this.activeTab = tab;
    // this.userCacheService.setUserData(AppConstants.CURRENT_NAV_TAB, tab);
    // const path = this.participantId +  '/' + tab;
    this.navigateTo(tab);
  }
  navigateTo(path): void {
    this.router.navigate([path]);
  }
}
